<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2024-01-09 16:11:07
 * @LastEditors: sjq
 * @LastEditTime: 2024-01-09 17:29:38
 -->
<template>
  <!-- 表单字段 -->
  <div v-if="formModel" class="form-field" :class="formSize">
    <!-- 标签 -->
    <div v-show="labelIsShow" class="field-label">{{ label }}</div>
    <!-- 元素：文本 -->
    <div v-if="type === 'text' || type === 'tel'" class="field-input">
      <input
        v-model="formModel[prop]"
        ref="input"
        :type="type"
        :readonly="readonly"
        class="field-input_inner"
        :maxlength="type === 'tel' ? 11 : maxlength || 50"
        :placeholder="placeholder"
      />
    </div>
    <!-- 元素：多行文本 -->
    <div v-if="type === 'textarea'" class="field-input">
      <textarea
        v-model="formModel[prop]"
        ref="input"
        class="field-input_inner type_textarea"
        :maxlength="maxlength || 500"
        :rows="rows"
        :placeholder="placeholder"
      />
    </div>
    <!-- 选择类（地区选择） -->
    <div v-if="type === 'select'" class="field-select_popup wrap_width">
      <SelectPopup
        ref="selectPopup"
        :text="formModel[prop]"
        :format="format"
        :options="options.options"
        @on-select="selectPopup"
      />
      <div class="field-select_popup_value" @click="openSelectPopup">
        <!-- 选择图标 -->
        <span v-if="formModel[prop]" class="select_value">{{ formModel[prop] }}</span>
        <span v-else class="placeholder">{{ options.placeholder }}</span>
        <img class="select_value_icon" src="../../../../assets/images/icon/icon_arrow_left.png" alt="" />
        <!-- <iconfont class="iconmore" /> -->
      </div>
    </div>
    <!-- 选择类（地区选择） -->
    <div v-if="type === 'selectAddress'" class="field-select_popup wrap_width">
      <AddressPopup
        ref="addressPopup"
        :text="formModel[prop]"
        :defaultValue="[formModel.provinceCode, formModel.cityCode, formModel.regionCode]"
        :format="format"
        :options="options.options"
        @on-select="addressPopup"
      />
      <div class="field-select_popup_value" @click="openAddressPopup">
        <!-- 选择图标 -->
        <span v-if="formModel[prop]" class="select_value">{{ formModel[prop] }}</span>
        <span v-else class="placeholder">{{ options.placeholder }}</span>
        <img class="select_value_icon" src="../../../../assets/images/icon/icon_arrow_left.png" alt="" />
        <!-- <iconfont class="iconmore" /> -->
      </div>
    </div>
    <!-- 开关 -->
    <div v-if="type === 'switch'" class="field-input field-switch" style="text-align: right">
      <van-switch v-model="formModel[prop]" active-color="#FF7142" inactive-color="#CCCCCC" size="16" />
    </div>
  </div>
</template>

<script>
import SelectPopup from './select-popup'
import AddressPopup from './address-popup'

import { Switch } from 'vant'

const componentName = 'FormField'
export default {
  name: componentName,

  componentName,
  components: { SelectPopup, AddressPopup, 'van-switch': Switch },
  props: {
    model: {
      type: Object,
      default: () => null
    },
    prop: {
      type: String,
      required: true
    },
    // 默认第一个元素选中
    defaultFocus: {
      type: Boolean,
      default: () => false
    },
    options: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    form() {
      let parent = this.$parent
      let parentName = parent.$options.componentName
      while (parentName !== 'FormEntity') {
        parent = parent.$parent
        parentName = parent.$options.componentName
      }
      return parent
    },
    formModel() {
      return this.model || this.form.model
    },
    formSize() {
      return this.model || this.form.size
    },
    label() {
      return this.options.label
    },
    readonly() {
      return this.options.readonly
    },
    placeholder() {
      return this.options.placeholder
    },
    maxlength() {
      return this.options.maxlength
    },
    rows() {
      return this.options.rows || 4
    },
    type() {
      return this.options.type
    },
    format() {
      return this.options.format
    },
    labelIsShow() {
      return this.type !== 'textarea'
    }
  },
  activated() {
    // 默认选择
    if (this.defaultFocus) {
      this.$refs.input.focus()
    }
  },
  methods: {
    openSelectPopup() {
      this.$refs.selectPopup.visible = true
    },
    openAddressPopup() {
      this.$refs.addressPopup.visible = true
    },
    // 选择列表
    addressPopup(selectValues) {
      this.$set(this.formModel, this.prop, selectValues.area)
      this.$set(this.formModel, 'addressOption', selectValues)
    },
    // 选择列表
    selectPopup(selectValues) {
      const format = selectValues.format
      const value = selectValues.value || {}
      if (format === 'area') {
        this.$log.debug(value)
        const values = Object.values(value)
        const selectText = values.map(a => a && a.value).join(' / ')
        this.$set(this.formModel, this.prop, selectText)
      } else {
        const { idKey, valueKey, idProp, valueProp } = this.options.options
        // this.$set(this.formModel, this.prop, value[idKey])
        this.$set(this.formModel, idProp, value[idKey])
        this.$set(this.formModel, valueProp, value[valueKey])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// 表单字段
.form-field {
  // 弹性模式
  display: flex;
  justify-content: space-between;
  align-items: center;
  // 间距、背景、字体
  padding: 0.4rem 0.48rem;
  background-color: #fff;
  border-bottom: 1px solid #f6f6f6;
  font-size: 0.28rem;
  // 字段标签
  .field-label {
    width: 30%;
    font-size: 0.28rem;
    color: #666666;
    text-align: left; // 标签在左侧
  }
  input {
    width: auto;
    border: none;
    outline: none;
    -webkit-user-select: auto !important;
    caret-color: #000000;
    font-size: 0.28rem;
  }
  textarea {
    width: auto;
    border: none;
    outline: none;
    -webkit-user-select: auto !important;
    caret-color: #000000;
    font-size: 0.28rem;
  }
  // 字段元素
  .field-input {
    flex: 1;
    input::-webkit-input-placeholder {
      font-size: 0.28rem;
      color: #cccccc;
    }
    // [type=input] 输入框
    .field-input_inner {
      width: 100%;
      border-width: 0;
      font-size: 0.28rem;
      text-align: right; // 输入在右侧
      color: #000000; // 输入的文本颜色
      outline: none;
      // [type=textarea] 文本域
      &.type_textarea {
        text-align: left; // 输入在左侧
        &::-webkit-input-placeholder {
          color: #cccccc;
        }
      }
    }
  }
  .wrap_width {
    width: 70% !important;
  }
  // 元素选择值
  .field-select_popup {
    width: 100%;
    padding: 5px 0px;
    .field-select_popup_value {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .select_value {
        flex: 1;
        font-size: 0.28rem;
        text-align: right; // 输入在右侧
        color: #000000; // 输入的文本颜色
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        display: block;
        white-space: nowrap;
      }
      .select_value_icon {
        margin-left: 0.16rem;
        width: 0.1rem;
        height: 0.16rem;
      }
      // 占位符
      .placeholder {
        flex: 1;
        text-align: right;
        font-size: 0.28rem;
        color: #cccccc;
      }
    }
  }
  &.small {
    padding: 0.31rem 0.45rem;
    .field-label,
    input,
    textarea,
    .select_value,
    .placeholder {
      font-size: 0.26rem !important;
    }
  }
}
</style>
